import React, { useContext, createContext } from 'react';
import { PricingExperiments } from '~shared/types/pricing/experiments';
import { PricingConfigStaticData } from '~shared/types/pricing/load-cache';

const BOOTSTRAP_CONTEXT: PricingExperiments = {
  priceExperiment: {
    hasAssignment: false,
    experimentName: null,
    treatmentName: null,
  },
  featureExperiment: {
    hasAssignment: false,
    experimentName: null,
    treatmentName: null,
  },
  uiExperiment: {
    hasAssignment: false,
    experimentName: null,
    treatmentName: null,
  },
};

// attempt to grab the cached experiments response to rehydrate when we make it to the browser
const win = typeof window !== 'undefined' ? window : undefined;
const payloadCache: PricingConfigStaticData | undefined =
  win && (win?.SM?.__LOAD_PAYLOAD_CACHE__ as PricingConfigStaticData);
const defaultContextValue = payloadCache?.experiments || BOOTSTRAP_CONTEXT;

export const PricingExperimentContext = createContext<PricingExperiments>(defaultContextValue);

export const PricingExperimentProvider = ({
  experiments,
  children,
}: {
  experiments: PricingExperiments | undefined;
  children: React.ReactNode;
}): React.ReactElement => (
  <PricingExperimentContext.Provider value={experiments || defaultContextValue}>
    {children}
  </PricingExperimentContext.Provider>
);

export function usePricingExperiments(): PricingExperiments {
  return useContext(PricingExperimentContext);
}
